import { GetterTree } from 'vuex'
import { CounterState, ICounterState } from './state';

export const counterGetters: GetterTree<CounterState, ICounterState> = {
  selectedSponsor: (state: CounterState) => state.selectedSponsor,
  selectedSponsorId: (state: CounterState) => state.selectedSponsorId,
  selectedSite: (state: CounterState) => state.selectedSite,
  selectedSiteId: (state: CounterState) => state.selectedSiteId,
  selectedMealDate: (state:CounterState) => state.selectedMealDate,
  featureFlags: (state: CounterState) => state.featureFlags,
  sites: (state: CounterState) => state.sites,
  sponsors: (state: CounterState) => state.sponsors,
  programs: (state: CounterState) => state.programs,
  selectedProgramId: (state: CounterState) => state.selectedProgramId,
  siteAppDates: (state: CounterState) => state.siteAppDates,
  pwaInstalled: (state: CounterState) => state.pwaInstalled,
  isOnline: (state: CounterState) => state.isOnline,
  isSyncing: (state: CounterState) => state.isSyncing,
  timeStamp: (state: CounterState) => state.timeStamp
};
